// extracted by mini-css-extract-plugin
export default {"image":"EventDetail_image__kVi6i","imgContainer":"EventDetail_imgContainer__Z6Wp8","sign":"EventDetail_sign__K6tA-","overlay":"EventDetail_overlay__TNcrH"};